import { useAuth } from "./useAuth";

/* 인사이트 세션 CRUD */
export default function useInsightJobs() {
  const { api } = useAuth();

  /* 세션 목록 */
  const listJobs = async () => {
    const { data } = await api.get("/ins/list");
    const arr = data?.data ?? [];
    return arr.map((j) => ({
      id: j.id,
      title: j.job_name,
      messages: [], // 채팅 패널과 동일한 형태 유지
    }));
  };

  /* 세션 생성 */
  const createJob = async (jobName) => {
    const { data } = await api.post("/ins/create", { job_name: jobName });
    if (!data.status) throw new Error("create_fail");
    return { id: data.job_id, title: jobName, messages: [] };
  };

  /* 세션 삭제 */
  const deleteJob = async (id) => {
    await api.post("/ins/delete", { session_id: id });
  };

  return { listJobs, createJob, deleteJob };
}
